import Top from '../../component/top/Top';
import History from '../../component/history/History';
import Strong from '../../component/strong/Strong';
import Financially from '../../component/financially/Financially';
import ContactBox from '../../component/enquiry/ContactBox';
import { Helmet } from 'react-helmet';

const AboutUs = () => {
  return (
    <>
      <Helmet>
        <title>Top 10 Solar Module Manufacturer</title>
        <meta name="description" content="As a Top 10 Solar Module Manufacturer in India, Gautam Solar offers a wide range of premium solar panels designed for maximum efficiency and long-term durability. With cutting-edge R&D and state-of-the-art production facilities, Gautam Solar’s modules meet global quality standards and deliver exceptional output even in challenging weather conditions." />

        <meta name="keywords" content="Top 10 Solar Module Manufacturer, top Solar Energy company in india, best Solar Module Manufacturer company, solar panel companies, solar panel for home" />

        <link rel="canonical" href="https://gautamsolar.com/aboutus/" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: "About Gautam Solar",
            url: "https://gautamsolar.com/aboutus/",
            mainEntity: {
              "@type": "Organization",
              name: "Gautam Solar",
              url: "https://gautamsolar.com/",
              description:
                "Gautam Solar is a Top 10 solar module manufacturer in India with over 25 years of experience, offering ALMM-listed Mono PERC and N-Type TOPCon solar panels manufactured with cutting-edge R&D and state-of-the-art production facilities.",
              location: [
                {
                  "@type": "Place",
                  name: "Haridwar Factory",
                  address: {
                    "@type": "PostalAddress",
                    streetAddress: "Plot-67 & 68, Sec-8A, SIDCUL",
                    addressLocality: "Haridwar",
                    addressRegion: "Uttarakhand",
                    addressCountry: "IN",
                  },
                },
                {
                  "@type": "Place",
                  name: "Bhiwani Factory",
                  address: {
                    "@type": "PostalAddress",
                    streetAddress: "7 KM Milestone, Tosham Road",
                    addressLocality: "Bhiwani",
                    addressRegion: "Haryana",
                    addressCountry: "IN",
                  },
                },
              ],
              hasCredential: [
                { "@type": "EducationalOccupationalCredential", name: "BIS Certified" },
                { "@type": "EducationalOccupationalCredential", name: "CE Certified" },
                { "@type": "EducationalOccupationalCredential", name: "IEC Certified" },
                { "@type": "EducationalOccupationalCredential", name: "TUV Certified" },
                { "@type": "EducationalOccupationalCredential", name: "UL Certified" },
                { "@type": "EducationalOccupationalCredential", name: "ALMM Listed (MNRE)" },
              ],
            },
          })}
        </script>
      </Helmet>

      <h1 className="sr-only">Strong Top Management</h1>
      <Top />
      <History />
      <Strong />
      <Financially />
      <ContactBox />
    </>
  );
};

export default AboutUs;